import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { ReportState, ReportTypes } from './types';

const INITIAL_STATE: ReportState = {
    data: [],
    loading: false,
    successOnGenerateAsyncReport: false,
    errorOnGenerateAsyncReport: false,
    currentReportId: undefined,
};

const reducer: Reducer<ReportState> = (state: ReportState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
        case ReportTypes.GENERATE_ASYNC_REPORT_CLEAR:
            return { ...INITIAL_STATE };
        case ReportTypes.GENERATE_ASYNC_REPORT_REQUEST:
            return { ...state, successOnGenerateAsyncReport: false, errorOnGenerateAsyncReport: false, loading: true };
        case ReportTypes.GENERATE_ASYNC_REPORT_SUCCESS:
            return {
                ...state,
                successOnGenerateAsyncReport: true,
                errorOnGenerateAsyncReport: false,
                loading: false,
                currentReportId: action.payload,
            };
        case ReportTypes.GENERATE_ASYNC_REPORT_FAILURE:
            const { error, reportId: currentReportId } = action.payload;
            return { ...state, successOnGenerateAsyncReport: false, errorOnGenerateAsyncReport: true, loading: false, error, currentReportId };
        case ReportTypes.LIST_REPORT_PROCESSES_REQUEST:
            return { ...state, loading: true };
        case ReportTypes.LIST_REPORT_PROCESSES_SUCCESS:
            const { reportId, reportProcesses } = action.payload;
            const oldReportProcess = state.data.filter((it) => it.reportId !== reportId);

            return {
                ...state,
                loading: false,
                data: [...oldReportProcess, { reportId, reportProcesses }],
            };
        case ReportTypes.LIST_REPORT_PROCESSES_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default reducer;
